import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 10px;
    > .audioPlayerCard {
        width: 100%;
        height: 150px;
        position: relative;
        
    }
    > .chat {
        overflow-y: scroll;
        padding-right: 20%;
        padding-left: 20%;
        margin-top: 10px;
        width: 100%;
        
        position: relative;
    }
}
`;

export const EmptyArea = styled.div`
    margin: auto;
    width: 50%;
    height: auto;
    position: relative;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
`;

export const StyledButton = styled(Button)`
    margin-top: 10px;
    margin-bottom: 10px;
    float: right;
    text-align : center;
`;
